import script from "./toolBar.vue?vue&type=script&setup=true&lang=js"
export * from "./toolBar.vue?vue&type=script&setup=true&lang=js"

import "./toolBar.vue?vue&type=style&index=0&id=07d4c8ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d4c8ce"]])

export default __exports__